/**
 * This file may contain code that uses generative AI for code assistance, unit testing and/or entire functions.
 * The generative model(s) used may be a combination of GitHub Copilot, OpenAI ChatGPT or others.
 */

import { getCommandIntelligenceTokens } from '../../theme/commandIntelligenceTokens';

/**
 * @param {import('@mui/material').Theme & { validateMode?: Function }} theme
 */
export const getCommandIntelligenceGenerationProgressStyles = theme => {
  const tokens = getCommandIntelligenceTokens(theme);

  return {
    root: {
      display: 'flex',
      flexDirection: 'column',
      gap: 0.75,
    },
    header: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      gap: 1,
      minWidth: 0,
    },
    headerLeft: {
      display: 'flex',
      alignItems: 'center',
      gap: 0.75,
      minWidth: 0,
    },
    title: {
      fontFamily: tokens.fontStack,
      fontSize: '0.82rem',
      fontWeight: 500,
      color: tokens.textPrimary,
      lineHeight: 1.35,
    },
    subtitle: {
      fontFamily: tokens.fontStack,
      fontSize: '0.72rem',
      color: tokens.textMuted,
      lineHeight: 1.3,
    },
    toolChip: {
      flexShrink: 0,
      height: 22,
      fontSize: '0.68rem',
      fontFamily: tokens.fontStack,
      borderRadius: tokens.radiusChip,
      bgcolor: tokens.bubbleUserBg,
      color: tokens.textSecondary,
      border: `1px solid ${tokens.bubbleUserBorder}`,
    },
    toggleButton: {
      display: 'inline-flex',
      alignItems: 'center',
      gap: 0.5,
      border: 0,
      bgcolor: 'transparent',
      color: tokens.textMuted,
      cursor: 'pointer',
      fontFamily: tokens.fontStack,
      fontSize: '0.72rem',
      p: 0,
      '&:hover': {
        color: tokens.textSecondary,
      },
    },
    steps: {
      display: 'flex',
      flexDirection: 'column',
      gap: 0.625,
      pl: 0.25,
    },
    stepRow: active => ({
      display: 'flex',
      alignItems: 'flex-start',
      gap: 0.75,
      color: active ? tokens.textPrimary : tokens.textMuted,
    }),
    stepIconBox: {
      width: 18,
      height: 18,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexShrink: 0,
      mt: '1px',
    },
    stepPendingDot: {
      width: 8,
      height: 8,
      borderRadius: '50%',
      border: `1.5px solid ${tokens.borderInput}`,
    },
    stepLabel: active => ({
      fontFamily: tokens.fontStack,
      fontSize: '0.78rem',
      fontWeight: active ? 500 : 400,
      lineHeight: 1.35,
    }),
    stepDetail: {
      fontFamily: tokens.fontStack,
      fontSize: '0.72rem',
      color: tokens.textMuted,
      lineHeight: 1.35,
      mt: 0.25,
    },
    collapsedSummary: {
      fontFamily: tokens.fontStack,
      fontSize: '0.72rem',
      color: tokens.textMuted,
      lineHeight: 1.35,
    },
  };
};
